import { render, staticRenderFns } from "./multiple-editor.vue?vue&type=template&id=bd1a2206&scoped=true"
import script from "./multiple-editor.vue?vue&type=script&lang=js"
export * from "./multiple-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1a2206",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd1a2206')) {
      api.createRecord('bd1a2206', component.options)
    } else {
      api.reload('bd1a2206', component.options)
    }
    module.hot.accept("./multiple-editor.vue?vue&type=template&id=bd1a2206&scoped=true", function () {
      api.rerender('bd1a2206', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/multiple-editor.vue"
export default component.exports